export const HOST_TKO = 'https://texcoloromsk.ru';

const MEDIA_PREFIX = '/media';

export const getDocLink = (src: string) => HOST_TKO + MEDIA_PREFIX + '/doc/' + src;
export const getBrandImgSrc = (src: string) => HOST_TKO + MEDIA_PREFIX + '/brands/' + src;
export const getCategoryImgSrc = (src: string) => HOST_TKO + MEDIA_PREFIX + '/catalog/' + src;
export const getHeroImgSrc = (src: string) => HOST_TKO + MEDIA_PREFIX + '/header/' + src;
export const getProductImgSrc = (src: string) => HOST_TKO + MEDIA_PREFIX + '/product/' + src;

export const getCatalogLink = (src: string) => '/catalog/' + src;
